<template>
  <div class="modal-plan-change-container" v-if="serviceInfo.service_type === 4">
    <sweet-modal ref="modal" @close="close" hideCloseButton>
      <template v-if="serviceInfo && serviceInfo.plan">
      <div class="plan-modal-title flex-between">
        <span>플랜 {{ serviceInfo.plan.trial ? '결제' : '변경' }}</span>
        <i class="material-icons unselect" @click="clickClose">close</i>
      </div>
      <div class="plan-modal-content">
        <component :is="`plan-change-step${step}`"
                   :service="serviceInfo"
                   :selectedItem="selectedItem"
                   :accounts="accounts"
                   @next="onNext"
                   @prev="onPrev"
                   @done="onDone"></component>
      </div>
      </template>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  import PlanChangeStep1 from "./Step/PlanChangeStep1";
  import PlanChangeStep2 from "./Step/PlanChangeStep2";
  import PlanChangeStep3 from "./Step/PlanChangeStep3";

  export default {
    name: "PlanChangeModal",
    components: {
      PlanChangeStep1,
      PlanChangeStep2,
      PlanChangeStep3,
      SweetModal
    },
    data() {
      return {
        step: 1,
        selectedItem: undefined,
        accounts: []
      }
    },
    methods: {
      open() {
        setTimeout(()=>{
          this.$refs.modal.open();
        },100);
      },
      clickClose() {
        this.$refs.modal.close();
      },
      close() {
        if(this.step === 3) {
          this.$emit('done');
        }
        setTimeout(()=>{
          this.step = 1;
        }, 500);
      },
      onNext(item) {
        if(this.step === 1) {
          this.selectedItem = item;
          this.step++;
        } else if(this.step === 2) {
          this.account(item);
        }
      },
      onPrev() {
        this.step--;
      },
      onDone(res) {
        this.$refs.modal.close();
        if(res === 'info' && this.$route.path.indexOf('/service/plan')===-1) {
          this.routerPush(this.getPath('service/plan'));
        }
      },
      account(item) {
        this.$root.$emit('onLoading', '결제 진행 중');
        this.$axios.post(`${this.masterBackendUrl}serviceadmin/${this.$store.getters.admin.id}/launchpack/v1/service/${this.serviceInfo.id}/plan_account`,
        item).then(res => {
          this.$root.$emit('offLoading');
          if(res.status === 200) {
            this.accounts = item.accounts;
            this.accounts = item.accounts.filter(i => i.type !== 'free');
            this.step++;

            this.$axios.get('admin/launchpack/service/info').then(r => {
              this.$store.commit('setMasterServiceInfo', r.data);
            });
          }
        }).catch(()=>{
          this.toast('결제 도중 오류가 발생했습니다.');
          this.$root.$emit('offLoading');
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .plan-modal-title
    background-color #242428
    color white
    font-size 16px
    font-weight 500
    padding 16px 24px
  .plan-modal-content
    width 100%
    max-height calc(100vh - 56px)
    overflow-y auto
</style>
<style lang="stylus">
  .modal-plan-change-container
    .sweet-modal-overlay
      -webkit-perspective initial
    .sweet-modal.is-alert
      width 1200px
    .sweet-modal.is-alert .sweet-content
      padding 0
</style>
